import { useState } from 'react';
import { Eye, Monitor, Smartphone, Tablet } from 'lucide-react';
import AuthenticatedWebsitePreview, { type PreviewViewport } from './AuthenticatedWebsitePreview';

interface WebsitePreviewPanelProps {
  section?: string;
  patch?: Record<string, unknown>;
  statusText?: string;
  titleText?: string;
}

const WebsitePreviewPanel: React.FC<WebsitePreviewPanelProps> = ({
  section,
  patch,
  statusText = 'Private website preview',
  titleText = 'Website preview - not published yet',
}) => {
  const [viewport, setViewport] = useState<PreviewViewport>('desktop');

  return (
    <div className="flex h-full min-h-0 flex-col bg-muted/30">
      <div className="flex h-12 shrink-0 items-center justify-between gap-3 border-b border-border bg-background px-3 sm:px-4">
        <div className="hidden items-center gap-2 text-sm font-semibold text-foreground sm:flex">
          <Eye className="size-4 text-primary" />
          {titleText}
        </div>
        <div className="mx-auto inline-flex rounded-md border border-border bg-muted/40 p-0.5 sm:mx-0">
          {([
            ['desktop', Monitor, 'Desktop preview'],
            ['tablet', Tablet, 'Tablet preview'],
            ['mobile', Smartphone, 'Mobile preview'],
          ] as const).map(([option, Icon, label]) => (
            <button
              key={option}
              type="button"
              onClick={() => setViewport(option)}
              className={`flex size-8 items-center justify-center rounded transition-colors ${viewport === option ? 'bg-background text-primary shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}
              aria-label={label}
              title={label}
            >
              <Icon className="size-4" />
            </button>
          ))}
        </div>
        <span className="hidden text-xs text-muted-foreground xl:block">{statusText}</span>
      </div>
      <div className="min-h-0 flex-1">
        <AuthenticatedWebsitePreview section={section} patch={patch} viewport={viewport} />
      </div>
    </div>
  );
};

export default WebsitePreviewPanel;